import { render } from "./universalHeader.vue?vue&type=template&id=9330669a&ts=true"
import script from "./universalHeader.vue?vue&type=script&lang=ts"
export * from "./universalHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__